import type { JSX } from "react";

import { Flex, Pill } from "@mantine/core";

import type { MessageTagProps } from "./types";

import classes from "./TimelineItem.module.css";

export function TextMask({ children, isExpanded }: { isExpanded: boolean; children: React.ReactNode }): JSX.Element {
    const className = isExpanded ? classes.textMaskExpanded : classes.textMaskNotExpanded;
    return (
        <Flex className={className} direction="column">
            {children}
        </Flex>
    );
}

export function MessageTag({ tagName }: MessageTagProps): JSX.Element {
    return (
        <Pill className={classes.messageTag} size="xs">
            {tagName}
        </Pill>
    );
}
